/**
 * The RedirectLinkContext type enforces specific string context value
 * expected by the redirect link endpoint.
 */
type RedirectLinkContext = "find-an-advisor"

/**
 * linkRedirectFormat formats a url for compliance with the RedirectLink handler
 * @param url the url to be set as the "to" param onthe redirect endpoint
 * @param ctx context identifier for the redirect endpoint
 */
export const linkRedirectFormat = (url: string, ctx: RedirectLinkContext) => {
  return `/link?to=${url}&ctx=${ctx}`
}
